import { MultiSelectQuestion, SortResponsesEnum } from '../../../types/Question';

// <select
//   label="Q2109"
//   cond="">
//   <title>In what country or region do you currently reside?</title>
//   <choice label="ch244" value="244">United States</choice>
//   <choice label="ch996" value="996">Other Country</choice>
// </select>
/**
 * Export question as XML-precursor data type.
 *
 * @export
 * @param {MultiSelectQuestion} question
 * @return {*}
 */
export default function toXmlType(question: MultiSelectQuestion) {
  const xmlJSData = {
    select: {
      _attributes: { label: `Q${question.id}` },
      title: question.title,
      choice: [
        ...question.options.map((o) => {
          return {
            _attributes: {
              label: `ch${o.id}`,
              value: `${o.id}`,
              exclusive: '0',
              open: '0',
              openSize: '0',
              randomize: `${question.sort_responses == SortResponsesEnum.Randomize ? 1 : 0}`,
            },
            _text: o.name,
          };
        }),
      ],
    },
  };
  if (question.add_noneoftheabove)
    xmlJSData.select.choice.push({
      _attributes: {
        label: `ch998`,
        exclusive: '1',
        value: '998',
        open: '0',
        openSize: '0',
        randomize: '0',
      },
      _text: 'None of the above',
    });
  if (question.add_other)
    xmlJSData.select.choice.push({
      _attributes: {
        label: `ch999`,
        exclusive: '1',
        value: '998',
        open: '1',
        openSize: '25',
        randomize: '0',
      },
      _text: 'Other',
    });
  return xmlJSData;
}
